import api from '@services/api';

class ImpersonationService {
  /**
   * Démarre une session d'impersonation
   * @param {number} targetUserId - ID de l'utilisateur à impersonner
   * @returns {Promise<Object>} Réponse avec le contexte d'impersonation
   */
  async startImpersonation(targetUserId) {
    try {
      const response = await api.post('/impersonation/start', {
        target_user_id: targetUserId
      });
      return response.data;
    } catch (error) {
      console.error('Failed to start impersonation:', error);
      throw error;
    }
  }

  /**
   * Termine la session d'impersonation
   * @returns {Promise<Object>} Réponse de confirmation
   */
  async endImpersonation() {
    try {
      const response = await api.post('/impersonation/end');
      return response.data;
    } catch (error) {
      console.error('Failed to end impersonation:', error);
      throw error;
    }
  }

  /**
   * Récupère le contexte d'impersonation actuel
   * @returns {Promise<Object>} Contexte d'impersonation
   */
  async getImpersonationContext() {
    try {
      const response = await api.get('/impersonation/context');
      return response.data;
    } catch (error) {
      console.error('Failed to get impersonation context:', error);
      throw error;
    }
  }
}

export const impersonationService = new ImpersonationService();
export default impersonationService;
